import { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import EditorToolbar, {
    formats,
    redoChange,
    undoChange,
} from './EditorToolbar';
import React from 'react';
// import { Label } from '@mui/icons-material';

// ----------------------------------------------------------------------

// const RootStyleInner = styled(Box)(({ theme }) => ({
//   borderRadius: theme.shape.borderRadius,
//   border: `solid 1px transparent`,
//   '&.Mui-focused': {
//       border: `solid 1px ${theme.palette.grey[800]}`,
//   },
// }));

const RootStyle = styled(Box)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    padding: `1px`,
    border: `solid 1px ${theme.palette.grey[500_32]}`,
    '&:hover': {
        border: `solid 1px ${theme.palette.grey[800]}`,
    },
    '&.Mui-focused': {
        border: `solid 2px ${theme.palette.grey[800]}`,
        padding: `0px`,
    },
    '& .ql-container.ql-snow': {
        borderColor: 'transparent',
        ...theme.typography.body1,
        // fontFamily: theme.typography.fontFamily,
        fontFamily: 'Times',
    },
    '& .ql-editor': {
        minHeight: 200,
        '&.ql-blank::before': {
            fontStyle: 'normal',
            color: theme.palette.text.disabled,
        },
        '& pre.ql-syntax': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.grey[900],
        },
    },
}));

// ----------------------------------------------------------------------

// export interface Props extends ReactQuillProps {
//   id?: string;
//   error?: boolean;
//   simple?: boolean;
//   helperText?: ReactNode;
//   sx?: BoxProps;
//   label?: string;
//   maxWord?: number;
//   // ref: object;
//   // ref: LegacyRef<ReactQuill>;
// }

export default function Editor({
    id = 'minimal-quill',
    error,
    value,
    onChange,
    simple = false,
    helperText,
    label,
    maxWord,
    // ref,
    sx,
    // ref,
    ...other
}) {
    const modules = {
        toolbar: {
            container: `#${id}`,
            handlers: {
                undo: undoChange,
                redo: redoChange,
            },
        },
        history: {
            delay: 500,
            maxStack: 100,
            userOnly: true,
        },
        syntax: true,
        clipboard: {
            matchVisual: false,
        },
    };

    const reactQuillRef = useRef(ReactQuill) || null;
    const [wordCount, setWordCount] = useState(0);
    const [editorValue, setEditorValue] =
        useState(ReactQuill.Value) || undefined;

    const editorChange = (text, delta, source, editor) => {
        var words = String(text)
            .replace(/<\/?[^>]+(>|$)/g, ' ')
            .replace(/\r?\n|\r/g, ' ')
            .replace(/\s\s+/g, ' ')
            .trim()
            .split(' ');
        setTimeout(
            (l) => {
                if (maxWord !== undefined) {
                    // setWordCount(Math.min(l,maxWord));
                    setWordCount(l);
                } else {
                    setWordCount(l);
                }
            },
            100,
            words.length,
        );

        setEditorValue(text);

        if (onChange !== undefined) {
            onChange(text, delta, source, editor);
        }
    };

    const handleKeyDown = (event) => {
        if (
            reactQuillRef.current !== null &&
            reactQuillRef.current.value !== null
        ) {
            var words = String(reactQuillRef.current.value)
                .replace(/<\/?[^>]+(>|$)/g, ' ')
                .replace(/\r?\n|\r/g, ' ')
                .replace(/\s\s+/g, ' ')
                .trim()
                .split(' ');
            if (maxWord !== undefined && words.length >= maxWord) {
                switch (event.key) {
                    case 'Delete':
                    case 'Backspace':
                    case 'ArrowUp':
                    case 'ArrowDown':
                    case 'ArrowLeft':
                    case 'ArrowRight':
                    case '.':
                        break;
                    default:
                        event.preventDefault();
                        return false;
                }
            }
        }
    };

    const handleFocus = (event) => {
        event.target.parentNode.parentNode.parentNode.classList.add(
            'Mui-focused',
        );
    };

    const handleBlur = (event) => {
        event.target.parentNode.parentNode.parentNode.classList.remove(
            'Mui-focused',
        );
    };

    useEffect(() => {
        setEditorValue(value);
        var words = String(value)
            .replace(/<\/?[^>]+(>|$)/g, ' ')
            .replace(/\r?\n|\r/g, ' ')
            .replace(/\s\s+/g, ' ')
            .trim()
            .split(' ');
        setWordCount(words.length);
    }, []);

    return (
        <div>
            <RootStyle
                onFocus={handleFocus}
                onBlur={handleBlur}
                sx={{
                    ...(error && {
                        border: (theme) =>
                            `solid 1px ${theme.palette.error.main}`,
                    }),
                    ...sx,
                }}
            >
                <label
                    style={{
                        marginTop: '-16px',
                        marginLeft: '8px',
                        position: 'absolute',
                        backgroundColor: '#fff',
                        padding: '4px',
                        fontSize: '0.9em',
                        color: '#919EAB',
                    }}
                >
                    {label}
                </label>
                <EditorToolbar
                    id={id}
                    isSimple={simple}
                    word_count={wordCount}
                    maxWord={maxWord}
                />
                <ReactQuill
                    value={editorValue}
                    onChange={editorChange}
                    onKeyDown={handleKeyDown}
                    modules={modules}
                    formats={formats}
                    ref={reactQuillRef}
                    placeholder="Write ..."
                    {...other}
                />
            </RootStyle>

            {helperText && helperText}
        </div>
    );
}
